export const staticRouteColors = [
    '#00e5e5',
    '#5a5a5a',
    '#ff00ff',
    '#6b5142',
    '#3f3f3f',
    '#6699ff',
    '#ff0000',
    '#99ff99',
    '#7d7d7d',
    '#990000',
    '#ebebc8',
    '#00dc00',
    '#ffff00',
    '#fa7d00',
    '#fa0064',
    '#8bc1c9',
    '#6b90ca',
    '#3030f0',
    '#787878',
    '#282828'
];
